import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STEPS } from "../../data/content";
import { CtaButton, Eyebrow, Reveal } from "./Primitives";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="system" data-testid="process-section" className="border-y border-ink/10 bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Eyebrow>Process & workflow</Eyebrow>
              <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl">One revenue system. <span className="font-serif font-normal italic text-cobalt-700">From prospect to customer.</span></h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-ink/70 sm:text-lg">You choose how much of the sales cycle Coenzio owns — from pure pipeline generation to the full journey through close and expansion.</p>
              <CtaButton testId="process-cta" className="mt-10">Design my revenue system</CtaButton>
            </Reveal>
          </div>
        </div>
        <div ref={ref} className="relative lg:col-span-7">
          <div className="absolute bottom-6 left-[27px] top-6 w-px bg-ink/10" />
          <motion.div style={{ scaleY }} className="absolute bottom-6 left-[27px] top-6 w-px origin-top bg-cobalt-700" />
          <ol className="space-y-4">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={0.05}>
                <li data-testid={`process-step-${i}`} className="group relative flex gap-6 rounded-3xl p-2 transition-colors duration-500 hover:bg-mist sm:gap-8">
                  <span className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-full border border-ink/15 bg-white font-mono text-[14px] font-semibold text-ink transition-colors duration-500 group-hover:border-cobalt-700 group-hover:bg-cobalt-700 group-hover:text-white">0{i + 1}</span>
                  <div className="pb-6 pt-2">
                    <h3 className="font-display text-3xl font-bold tracking-[-0.02em] text-ink sm:text-4xl">{s.title}</h3>
                    <div className="mt-4 flex flex-wrap gap-2">
                      {s.items.map((it) => <span key={it} className="rounded-full border border-ink/10 bg-paper px-3 py-1.5 text-[13px] font-medium text-ink/75">{it}</span>)}
                    </div>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
